import * as React from "react";
import { ConfirmDialog } from "@nuorder/components";
import {
    AssortmentDialogContextProvider,
    AssortmentTypeSelector,
    DimensionsDropdowns,
    selectedDimensionValues,
    useAssortmentDialogReducer,
    BrandPicker,
    MerchantDropdownOptions,
    FormValues,
} from "components";
import { AssortmentType } from "containers/folders/types/base";
import { formatMessage } from "lib/globalize-util";

export type EditAssortmentDialogProps = {
    onClose: () => void;
    onConfirm: (dimensionValues: selectedDimensionValues) => void;
    dimensionsDropdownOptions: MerchantDropdownOptions[];
    formValues: FormValues;
};

export const EditAssortmentDialog: React.FC<EditAssortmentDialogProps> = ({
    onClose,
    dimensionsDropdownOptions,
    formValues,
    onConfirm,
}) => {
    const [state, dispatch] = useAssortmentDialogReducer({
        isEditing: true,
        formValues,
    });

    const shouldRenderBrandPicker = state.formValues.assortmentType === AssortmentType.External;

    const handleSubmit = () => {
        onConfirm(state.formValues.dimensionsValues);
    };

    return (
        <ConfirmDialog
            contentProps={{ title: formatMessage("Update Assortment") }}
            onClose={onClose}
            onConfirm={handleSubmit}
            open={true}
            okLabel={formatMessage("Save")}
            cancelLabel={formatMessage("Cancel")}
            closeButtonAriaLabel={formatMessage("Close")}
        >
            <AssortmentDialogContextProvider value={{ ...state, dispatch }}>
                <AssortmentTypeSelector />
                <DimensionsDropdowns merchantDimensionsOptions={dimensionsDropdownOptions} />
                {shouldRenderBrandPicker && <BrandPicker />}
            </AssortmentDialogContextProvider>
        </ConfirmDialog>
    );
};
